import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const packagingSubCategoriesApi = createApi({
    reducerPath: "packagingSubCategoriesApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["PackagingSubCategories"],
    endpoints: (builder) => ({
        // Get all Packaging Subcategories. The list endpoint defaults to a
        // page size of 20 (server max 100), which silently drops entries
        // past that once the list grows - every consumer expects the full
        // list, so request the max explicitly.
        getPackagingSubCategories: builder.query({
            query: () => "/packaging-subcategories?limit=100",
            transformResponse: (response) => response.data || response,
            providesTags: ["PackagingSubCategories"],
        }),

        // Get a single Packaging Subcategory
        getPackagingSubCategoryById: builder.query({
            query: (id) => `/packaging-subcategories/${id}`,
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [
                { type: "PackagingSubCategories", id },
            ],
        }),

        // Create a new Packaging Subcategory
        createPackagingSubcategory: builder.mutation({
            query: (packageSubCategory) => ({
                url: `/packaging-subcategories`,
                method: "POST",
                body: packageSubCategory,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["PackagingSubCategories"],
        }),

        // Update an existing Packaging Subcategory
        updatePackagingSubcategory: builder.mutation({
            query: ({ id, body, ...packageSubCategory }) => ({
                url: `/packaging-subcategories/${id}`,
                method: "PUT",
                body: body || packageSubCategory,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["PackagingSubCategories"],
        }),

        // Delete an existing Packaging Subcategory
        deletePackagingSubcategory: builder.mutation({
            query: (id) => ({
                url: `/packaging-subcategories/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["PackagingSubCategories"],
        }),
    }),
});

export const {
    useGetPackagingSubCategoriesQuery,
    useGetPackagingSubCategoryByIdQuery,
    useCreatePackagingSubcategoryMutation,
    useUpdatePackagingSubcategoryMutation,
    useDeletePackagingSubcategoryMutation,
} = packagingSubCategoriesApi;
